import { mapGetters, mapActions } from 'vuex'

export default {
  data() {
    return {
      currentItem: {},
    }
  },
  computed: {
    ...mapGetters([
      'set_website_slug',
      'selectedOffer',
      'selected_category',
      'all_store_categories',
      'currentStoreSlug',
      'currentDeliveryArea',
      'selectedBrandData',
    ]),
  },
  methods: {
    ...mapActions(['addItemToCart']),
    addToCartMobile(item) {
      if (item.item_type === 'combo_item') {
        this.$store.commit(
          'combo_items_store/ACTIVE_COMBO_ITEMS',
          {},
          { root: true }
        )
        this.$store.commit('combo_items_store/SET_COMBO_ITEMS', { ...item })
        this.$store.commit('combo_items_store/SUB_ITEM_LIST', false)
        this.$store.commit('combo_items_store/SET_MODIFIERS', false)
        this.$store.dispatch('combo_items_store/updateOrderIndex')
        this.$store.commit(
          'combo_items_store/SET_SELECTED_ITEM_DATA',
          item.combo_items[0]
        )
        this.$store.dispatch('combo_items_store/findItemById')
        this.$bvModal.show('combo-items-container')
      } else {
        this.$store.commit('SELECT_MODIFIERS', {})
        this.$store.commit('SELECT_ITEM', item)
      }
    },
    path_is(item) {
      // let delivery_area = this.currentDeliveryArea
      if (!item) return false
      let category = this.all_store_categories.find(
        category => category._id === item.category
      )
      if (!category) return false
      // path = `/category/${category.slug}/product/${item.slug}`
      let scope = this
      this.$router.replace({
        name: 'category_product_landing_page',
        params: {
          brand_id: scope.set_website_slug(scope.selectedBrandData),
          category_name: category.slug,
          product_id: item.slug,
          delivery_area: scope.currentDeliveryArea,
        },
      })
      // if (related === 'category') {
      /*else {
        if (item.category && this.quickViewDetails) {
          let category_name = category.slug
          path += '/category/' + category_name
        }
      }*/
      // if (item.slug) {
      //   this.$store.commit('SELECT_MODIFIERS', {})
      //   this.$store.commit('SELECT_ITEM', item)
      //   this.$store.commit('PRODUCT_DETAILS_PAGE', true)
      //   path += `/${this.set_website_slug(this.selectedBrandData)}/${this.store_slug}/product/${item.slug}`
      // }
      // this.item_path = path + `/${delivery_area}`
    },

    addToCart(item) {
      this.path_is(item)
      if (item.item_type === 'combo_item') {
        this.$store.commit(
          'combo_items_store/ACTIVE_COMBO_ITEMS',
          {},
          { root: true }
        )
        this.$store.commit('combo_items_store/SET_COMBO_ITEMS', { ...item })
        this.$store.commit('combo_items_store/SUB_ITEM_LIST', false)
        this.$store.commit('combo_items_store/SET_MODIFIERS', false)
        this.$store.dispatch('combo_items_store/updateOrderIndex')
        this.$store.commit(
          'combo_items_store/SET_SELECTED_ITEM_DATA',
          item.combo_items[0]
        )
        this.$store.dispatch('combo_items_store/findItemById')
        this.$bvModal.show('combo-items-container')
      } else {
        this.$store.commit('SELECT_MODIFIERS', {})
        this.$store.commit('SELECT_ITEM', item)
        this.$store.commit('SET_ITEM_DETAIL_POPUP', true)
        // Commenting this line
        // Because now we need to scroll menu items when popup is open
        // document.body.classList.add('body-overlay')
      }
    },
  },
}
